import { useCallback, useRef } from 'react'

export interface UseTimeoutReturnValue {
  start: (...args: any[]) => void
  clear: () => void
}

export function useTimeout(callback: (...args: any[]) => void, delay: number): UseTimeoutReturnValue {
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>(null)

  const start = useCallback(
    (...args: any[]) => {
      if (!timeoutRef.current) {
        timeoutRef.current = setTimeout(() => {
          callback(...args)
          timeoutRef.current = null
        }, delay)
      }
    },
    [callback, delay]
  )

  const clear = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
      timeoutRef.current = null
    }
  }, [])

  return { start, clear }
}
